import { Button, cn } from '@simplywallst/ui-core/next';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';

type Props = {
  handleBannerDismissed: () => void;
  content: string;
};

export const NarrativesBanner = ({ handleBannerDismissed, content }: Props) => {
  const { isMobile } = useUserAgent();

  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  const containerClassName = cn(
    'relative mx-x2 mb-x2 grid gap-x1 rounded-x1 bg-p-grey-30 p-x1_5 lg:mx-0',
    {
      'grid-cols-[1fr_auto] items-start': isMobileScreen,
      'grid-cols-[1fr_auto_auto] items-center pl-x2': !isMobileScreen,
    }
  );

  const WHATS_A_NARRATIVE = "What's a narrative?";

  return (
    <div
      role="alert"
      className={containerClassName}
      data-testid="narratives-banner"
    >
      <p className="m-0 text-xs text-solid">{content}</p>
      {isMobileScreen ? (
        <>
          <Button
            aria-label="close"
            variant="subtle"
            size="medium"
            onClick={handleBannerDismissed}
          >
            <CrossSolid />
          </Button>
          <Button
            aria-label={WHATS_A_NARRATIVE}
            variant="outline"
            target="_blank"
            href="https://www.youtube.com/watch?v=lbOjxgYSJ0A"
            className={'col-span-2'}
            size="medium"
          >
            {WHATS_A_NARRATIVE}
          </Button>
        </>
      ) : (
        <>
          <Button
            aria-label={WHATS_A_NARRATIVE}
            variant="outline"
            target="_blank"
            href="https://www.youtube.com/watch?v=lbOjxgYSJ0A"
            size="medium"
          >
            {WHATS_A_NARRATIVE}
          </Button>
          <Button
            aria-label="close"
            variant="subtle"
            size="medium"
            onClick={handleBannerDismissed}
          >
            <CrossSolid />
          </Button>
        </>
      )}
    </div>
  );
};
